const client = {
  ELASTIC_URL: 'https://search.autocenterapp.com',
  ELASTIC_AUTH: `Basic ${btoa('servidor:autocenter')}`,
};

export { client };
